
import { STACK, ApiClient } from '@/Ship';

export default function (payload) {
    return STACK.push(() => ApiClient.post('/reset-password', payload));
}
